import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 6C4.10457 6 5 5.10457 5 4C5 2.89543 4.10457 2 3 2C1.89543 2 1 2.89543 1 4C1 5.10457 1.89543 6 3 6Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10C1.89543 10 1 10.8954 1 12C1 13.1046 1.89543 14 3 14Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 22C4.10457 22 5 21.1046 5 20C5 18.8954 4.10457 18 3 18C1.89543 18 1 18.8954 1 20C1 21.1046 1.89543 22 3 22Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0588 5H7.94118C7.42141 5 7 4.55225 7 4C7 3.44775 7.42141 3 7.94118 3H22.0588C22.5786 3 23 3.44775 23 4C23 4.55225 22.5786 5 22.0588 5Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0588 13H7.94118C7.42141 13 7 12.5523 7 12C7 11.4477 7.42141 11 7.94118 11H22.0588C22.5786 11 23 11.4477 23 12C23 12.5523 22.5786 13 22.0588 13Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0588 21H7.94118C7.42141 21 7 20.5527 7 20C7 19.4473 7.42141 19 7.94118 19H22.0588C22.5786 19 23 19.4473 23 20C23 20.5527 22.5786 21 22.0588 21Z",
			fill: "#636C7B"
		})
	]
});
export default SvgListView;
